import { Mapper } from '../../../../domain/adapters/mapper.adapter';
import { CategoryModel } from '../../../../domain/models/category.model';
import { CategoryEntity } from '../categories.responses';

export class CategoryEntityMapper extends Mapper<
  CategoryEntity,
  CategoryModel
> {
  mapFrom(entity: CategoryEntity): CategoryModel {
    return { ...entity };
  }

  mapTo(model: CategoryModel): CategoryEntity {
    throw new Error('Method not implemented.');
  }
}
